import _ from 'lodash'

export const moveModalOnFocus = (state, domElem) => {
  try {
    if (window.self !== window.top || !domElem) {
      let clientY = domElem.getBoundingClientRect().top
      if (state.getIn(['widgets', 'isShowSFMessage'], false)) {
        let modal = document.getElementsByClassName('sf-validation-message')
        if (modal && modal[0]) {
          modal = modal[0]
          let size = modal.getBoundingClientRect().height + 20
          let halfSize = size / 2
          let localTop = Math.max(clientY - halfSize, 0)
          if (clientY + size > window.innerHeight) {
            localTop = window.innerHeight - size - 20
          }
          let top = Math.max(localTop, 0)
          modal.style.top = top + 'px'
          setTimeout(function () {
            modal.style.top = top + 'px'
          }, 30)
        }
      }
    }
  } catch (err) {
    console.error(err)
  }
}
